import React, { useMemo } from "react";
import { useApiClient } from "../../../shared/customHooks";
import { useApplicationContext } from "../context/applicationContext";
import { applicationCreationForm } from "../../../shared/formObjects/application/applicationCreationForm";
import BaseApplicationComponent from "../../../shared/baseComponent/baseWrappers/BaseApplicationComponent";

function ApplicationCreationComponent({ disabled, data }: any) {
  const api = useApiClient("ApplicationCreation");
  const { id } = useApplicationContext();
  const formContext = useMemo(() => disabled, []);
  return (
    <BaseApplicationComponent
      formBody={applicationCreationForm}
      headerLabel="Application Creation"
      editPath="applicationCreation"
      apiClient={api}
      disabled={disabled}
      data={data}
      id={id}
      formContext={formContext}
      print={true}
      doFetch={true}
    />
  );
}

export default ApplicationCreationComponent;
